import { ChatInteractions, UserData } from '../server/types';

// Admin state data class
class AdminStateData {
	loggedIn: boolean
	customers: UserData[] | undefined
	instructors: UserData[] = []
	interactions: ChatInteractions[] = []

	constructor() {
		this.loggedIn = false
	}

	public logOut() {
		this.loggedIn = false
	}

	public setLoggedIn(value: boolean) {
		this.loggedIn = value
	}

	// ================================================== Sets =============================================

	public getCustomers(): UserData[] {
		return this.customers ? this.customers : []
	}
	
	public getInstructors(): UserData[] {
		return this.instructors ? this.instructors : []
	}

	public getInteractions(): ChatInteractions[] {
		return this.interactions ? this.interactions : []
	}

	public getCustomersWithStatus(status: string): UserData[] {
		return this.customers ? this.customers.filter((customer: UserData) => customer.status === status) : []
	}

	public getInstructorsWithStatus(status: string): UserData[] {
		return this.instructors ? this.instructors.filter((instructor: UserData) => instructor.status === status) : []
	}

	public getInteractionsWithStatus(status: string): ChatInteractions[] {
		return this.interactions ? this.interactions.filter((interaction: ChatInteractions) => interaction.status === status) : []
	}

	public getFlaggedCustomers(): UserData[] {
		return this.customers ? this.customers.filter((customer: UserData) => customer.status === 'FLAGGED') : []
	}

	public getFlaggedInstructors(): UserData[] {
		return this.instructors ? this.instructors.filter((customer: UserData) => customer.status === 'FLAGGED') : []
	}

	public setCustomers(value: UserData[]) {
		this.customers = value
	}
	public setInstructors(value: UserData[]) {
		this.instructors = value
	}
	public setInteractions(value: ChatInteractions[]) {
		this.interactions = value
	}
}

export const adminStateData: AdminStateData = new AdminStateData()